// environmentsApi — thin wrapper around assetManagerApi org environment endpoints.
// Kept as a separate module for callers that import from here by name.
// Per CLAUDE.md UX rules: NO silent fallbacks. Errors throw so callers can
// surface them via the App-level error overlay instead of pretending the list
// is empty when the server is unreachable.
//
// NOTE: These are now org-wide environments (shared across all characters).
// The slug parameter is accepted for backwards compatibility but ignored.

import {
  listOrgEnvironments,
  uploadOrgEnvironment,
  updateOrgEnvironment,
  deleteOrgEnvironment,
} from './assetManagerApi.js'

export async function listEnvironments(slug) {
  // slug parameter kept for backwards compatibility but ignored
  // — all environments are org-wide now
  return listOrgEnvironments()
}

export async function getEnvironment(slug, id) {
  if (!id) throw new Error('getEnvironment: id required')
  // slug parameter kept for backwards compatibility but ignored
  // No dedicated GET-by-id endpoint — fetch the list and filter.
  const all = await listOrgEnvironments()
  const found = all.find(e => e.id === id)
  if (!found) throw new Error(`org environment get failed: ${id} not found`)
  return found
}

export async function uploadEnvironment(slug, file, meta = {}) {
  if (!file) throw new Error('uploadEnvironment: file required')
  // slug parameter kept for backwards compatibility but ignored
  // — all uploads go to org bucket now
  const fd = new FormData()
  fd.append('file', file, file.name)
  if (meta.name) fd.append('name', meta.name)
  if (meta.folderPath) fd.append('folder_path', meta.folderPath)
  if (meta.defaultPose) fd.append('default_pose', JSON.stringify(meta.defaultPose))
  return uploadOrgEnvironment(fd)
}

export async function patchEnvironment(slug, id, patch) {
  if (!id) throw new Error('patchEnvironment: id required')
  // slug parameter kept for backwards compatibility but ignored
  return updateOrgEnvironment(id, patch)
}

export async function deleteEnvironment(slug, id) {
  if (!id) throw new Error('deleteEnvironment: id required')
  // slug parameter kept for backwards compatibility but ignored
  return deleteOrgEnvironment(id)
}
